// extracted by mini-css-extract-plugin
export default {"lntAvatar":"styles_lnt-avatar__A67Kf"};